import React from "react";
import { useTranslation } from "react-i18next";

type buttonsSectionProps = {
  handleSubmit?: () => void;
  setModalShow: (modalState: boolean) => void;
  setIsBackNavigation?: (isBack: boolean) => void;
  approveBtnLabel?: string;
  currStep?: number;
  isSubmitButtonDisable?: boolean;
  isSubmitButtonShow?: boolean;
};
const ButtonsSEctionReportDetails = ({
  handleSubmit = () => {},
  currStep,
  setModalShow,
  setIsBackNavigation,
  approveBtnLabel,
  isSubmitButtonDisable = false,
  isSubmitButtonShow = true,
}: buttonsSectionProps) => {
  const { t } = useTranslation();
  const approveLabel = approveBtnLabel ?? t("continue");
  // if we are in the first step we show modal to user, else we want to go back but first to submit the form
  const handleBackClick = () => {
    if (currStep === 1) {
      setModalShow(true);
    } else {
      setIsBackNavigation(true);
      handleContinue();
    }
  };

  const handleContinue = () => {
    handleSubmit();
  };

  return (
    <section className="report-btnsSetion">
      <button
        type="button"
        className="btn white arrowRight half-width"
        onClick={handleBackClick}
      >
        {t("labelBack")}
      </button>
      <button
        type="submit"
        className="btn blue half-width"
        onClick={handleContinue}
        disabled={isSubmitButtonDisable}
        style={{ display: isSubmitButtonShow ? "block" : "none" }}
      >
        {approveLabel}
      </button>
    </section>
  );
};
export default ButtonsSEctionReportDetails;
